import { AccountantTopDashboardContainer } from "../UI/Containers/AccountantDashboardContainer"
import { AllSectionsProps } from "../UI/Cards/Interfaces/DashboardContainer"
import { AdminDashboard, CEODashboard, DesignerDashboard, EstimatorDashboard, FacilitatorDashboard, ITDashboard, PurchaserDashboard } from "../UI/Section/RoleDashboards"

/**
 * This is a factory function that returns the top portion of the dashboard based on the role. IE The Projects, Tasks, etc.
 * @param role - The role of the user
 * @param props - The props to pass to the container
 * @returns The correct container based on the role
 */
export function DashboardFactory(role: string, props: AllSectionsProps) {
    switch (role) {
        case "Accountant":
            return <AccountantTopDashboardContainer {...props} />
        case "Administrator":
            return <AdminDashboard {...props} />
        case "CEO":
            return <CEODashboard {...props} />
        case "Estimator":
            return <EstimatorDashboard {...props} />
        case "Designer":
            return <DesignerDashboard {...props} />
        case "Purchaser":
            return <PurchaserDashboard {...props} />
        case "Facilitator":
            return <FacilitatorDashboard {...props} />
        case "IT":
            return <ITDashboard {...props} />
        default:
            throw new Error(`Role ${role} not found in DashboardFactory`)
    }
}